<template>
	<div class="k__ytb k__component" v-if="videoId">
		<img
			:src="hqdefault"
			:alt="title"
			loading="lazy"
			@click="play"
			ref="thumbnail"
		>

		<teleport
			v-if="modal"
			to="body"
		>
			<div
				class="modal modal__videos"
				:id="`modal-ytb-${uid}`"
				ref="modal"
			>
				<div class="modal-dialog">
					<div class="modal-content">
						<div class="modal-header">
							<button class="btn-close" type="button" data-bs-dismiss="modal" role="button" aria-label="Close"></button>
						</div>
						<div class="modal-body" ref="modalBody"></div>
					</div>
				</div>
			</div>
		</teleport>
	</div>
</template>

<script>
import { Modal } from 'bootstrap'

const addPrefetch = (url, rel, as) => {
	const link = document.createElement('link')

	link.href = url
	link.rel = rel

	if(as) link.as = as

	document.head.appendChild(link)
}

export default {
	name: 'KYtb',
	props: {
		url: {
			type: String,
			required: true
		},
		title: String,
		playsinline: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			iframe : null,
			bsModal: null
		}
	},
	computed: {
		hqdefault() {
			return `https://i.ytimg.com/vi/${this.videoId}/hqdefault.jpg`;
		},
		modal() {

			return !this.playsinline
		},
		uid() {
			return this._uid
		},
		videoId() {
			const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
			const match = this.url.match(regExp);

			return (match&&match[7].length==11)? match[7] : false;
		}
	},
	methods: {
		play() {
			if(this.playsinline) {
				return this.selfHost()
			}

			return this.modalHosted()
		},
		modalHosted() {
			if(this.iframe == null) this.createIframe()

			this.bsModal.show()
			this.$refs.modalBody.appendChild(this.iframe)
		},
		selfHost () {
			if(this.iframe == null) this.createIframe()

			this.$el.appendChild(this.iframe)
		},
		createIframe() {
			const params = new URLSearchParams([])
			const iframe = document.createElement('iframe')
			const id     = encodeURIComponent(this.videoId)

			params.append('autoplay', '1')
			params.append('rel', '0')

			iframe.width           = this.$el.offsetWidth
			iframe.height          = this.$el.offsetHeight
			iframe.title           = 'play'
			iframe.allow           = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
			iframe.allowFullscreen = true
			iframe.src             = `https://www.youtube-nocookie.com/embed/${id}?${params.toString()}`

			this.iframe = iframe;
		},
		setYtbConnection() {
			addPrefetch('https://www.youtube-nocookie.com', 'preconnect')
			addPrefetch('https://i.ytimg.com', 'preconnect')

			window.kytb = {
				connected: true
			}
		}
	},
	beforeMount() {
		if(!window.kytb || !window.kytb.connected) {
			this.setYtbConnection()
		}

		addPrefetch('preload', this.hqdefault, 'image')
	},
	mounted() {
		if(this.$refs.modal) {
			this.bsModal = new Modal(this.$refs.modal)

			this.$refs.modal.addEventListener('hidden.bs.modal', () => {
				this.$refs.modalBody.removeChild(this.iframe)
			})
		}
	}
}
</script>

<style lang="scss">
@use "sass:math";

.k-ytb,
k-ytb{
	background-color: #000;
	background-size: cover;
	background-position: center center;
	margin-bottom: 10px;
	position: relative;
	display: block;

	&::before{
		content:'';
		display: block;
		padding-bottom: percentage(
			math.div(1080, 1920)
		);
	}

	&:empty{
		&::after{
			content:'';
			position: absolute;
			left: 50%;
			top: 50%;
			z-index: 1;

			background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 68 48"><path d="M66.52 7.74c-.78-2.93-2.49-5.41-5.42-6.19C55.79.13 34 0 34 0S12.21.13 6.9 1.55c-2.93.78-4.63 3.26-5.42 6.19C.06 13.05 0 24 0 24s.06 10.95 1.48 16.26c.78 2.93 2.49 5.41 5.42 6.19C12.21 47.87 34 48 34 48s21.79-.13 27.1-1.55c2.93-.78 4.64-3.26 5.42-6.19C67.94 34.95 68 24 68 24s-.06-10.95-1.48-16.26z" fill="red"/><path d="M45 24 27 14v20" fill="white"/></svg>');
			filter: grayscale(100%);
			background-size: 100% 100%;

			width: 68px;
			height: 48px;

			transform: translate3d(-50%, -50%, 0);
			transition: filter .1s cubic-bezier(0, 0, 0.2, 1);
		}

		&:hover{
			cursor: pointer;

			&::after{
				filter: grayscale(0);
			}
		}
	}

	iframe{
		width: 100%;
		height: 100%;

		position: absolute;
		left: 0;
		top: 0;
		z-index: 3;
	}
}

.k__ytb{
	position: relative;
	background: #000;
	cursor: pointer;

	&::before{
		content: '';
		display: block;
		padding-bottom: 56.25%; // 16:9
		pointer-events: none;
	}

	img {
		position: absolute;
		left: 0;
		top: 0;
		z-index: 0;

		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	iframe{
		width: 100%;
		height: 100%;

		position: absolute;
		left: 0;
		top: 0;
		z-index: 3;
	}

	&::after{
		content:'';
		background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 68 48"><path d="M66.52 7.74c-.78-2.93-2.49-5.41-5.42-6.19C55.79.13 34 0 34 0S12.21.13 6.9 1.55c-2.93.78-4.63 3.26-5.42 6.19C.06 13.05 0 24 0 24s.06 10.95 1.48 16.26c.78 2.93 2.49 5.41 5.42 6.19C12.21 47.87 34 48 34 48s21.79-.13 27.1-1.55c2.93-.78 4.64-3.26 5.42-6.19C67.94 34.95 68 24 68 24s-.06-10.95-1.48-16.26z" fill="red"/><path d="M45 24 27 14v20" fill="white"/></svg>');

		filter: grayscale(100%);
		transition: filter .1s cubic-bezier(0, 0, 0.2, 1);

		width: 68px;
		height: 48px;

		position: absolute;
		left: 50%;
		top: 50%;
		z-index: 0;

		transform: translate3d(-50%, -50%, 0);
		background-size: 100% 100%;
		pointer-events: none;
	}

	&:hover{
		&::after{
			filter: none;
		}
	}
}

.modal__videos{

	.modal-dialog{
		max-width: calc(
			(100vh - 3.5rem - 90px) * (16 / 9)
		);
	}

	.modal-content{
		background: rgba(#fff,.5);
	}

	.modal-body{
		position: relative;
		padding-top: 0;
		padding-left: 0;
		padding-right: 0;
		padding-bottom: percentage(
			math.div(9,16)
		);
		background: #000;
		border-radius: 0 0 .25rem .25rem;

		iframe {
			border-radius: 0 0 .25rem .25rem;
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
		}
	}
}

</style>
